const SvgResize = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 61 60">
    <path fill="#191919" d="m10.2 5-4 5h8zM10.2 40l4-5h-8zM55.2 49.003 50.2 45v8zM19.2 49.003l5 3.997v-8z" />
    <path fill="#373737" fillRule="evenodd" d="M55.7 4.629v36.389H19.311V4.629zm-35.389 1v34.389h34.39V5.629zm-9.61 4.472v25h-1v-25zm13.25 38.25H50.2v1H23.95z" clipRule="evenodd" />
  </svg>;
export default SvgResize;